import React from 'react'
import { Outlet } from 'react-router'
import { useLocation } from 'react-router-dom'

import { Aside } from '@components/Aside'
import { Footer } from '@components/Footer'

import type { AuthLayoutProps } from './AuthLayout.props'

export function AuthLayout({ ...props }: AuthLayoutProps) {
  const location = useLocation()

  return (
    <>
      <div
        className={'auth-layout'}
        // style={{ minHeight: '100dvh' }}
      >
        {location.pathname !== '/auth/sign-in' && <Aside variant="mush" />}
        <main className={'main'}>
          <Outlet />
        </main>
      </div>
      {location.pathname !== '/auth/sign-in' && <Footer />}
    </>
  )
}
